import { useEffect, useMemo, useState } from 'react';

/**
 * ModularMultipleChoice — viewport → AmiraIconButton2 size props.
 * Tiers (wide → narrow): **normal** (baseline, no flags) → **small** → **xs**.
 *
 * Width is `window.innerWidth` (CSS pixels):
 *   [smallMin, ∞)     → normal
 *   [xsMin, smallMin) → small
 *   [0, xsMin)        → xs
 */
export const MMC_ICON_BREAKPOINTS = {
  repeat: { smallMin: 900, xsMin: 600 },
  submit: { smallMin: 900, xsMin: 600 },
};

/** Props for AmiraIconButton2; only one of small | xs is true, or neither for normal. */
function sizePropsForWidth(width, { smallMin, xsMin }) {
  if (width < xsMin) {
    return { small: false, xs: true, large: false, xl: false };
  }
  if (width < smallMin) {
    return { small: true, xs: false, large: false, xl: false };
  }
  return { small: false, xs: false, large: false, xl: false };
}

export function getMmcIconButtonSizeProps(viewportWidth) {
  return {
    repeat: sizePropsForWidth(viewportWidth, MMC_ICON_BREAKPOINTS.repeat),
    submit: sizePropsForWidth(viewportWidth, MMC_ICON_BREAKPOINTS.submit),
    viewportWidth,
  };
}

export function useMmcResponsiveIconButtonProps() {
  const [viewportWidth, setViewportWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return useMemo(() => getMmcIconButtonSizeProps(viewportWidth), [viewportWidth]);
}
